<template>
  <div class="help-center">
    <div class=" main">
      <card>
        <div v-if="question.question">
          <el-tabs v-model="activeName">
            <el-tab-pane
              v-for="domain in domains"
              :key="domain.language"
              :label="`Text ${domain.language.toUpperCase()}`"
              :name="`Text ${domain.language.toUpperCase()}`"
            >
              <base-input
                :label=" domain.language === 'en' ? `Question ${domain.language.toUpperCase()} (required field)` : `Question ${domain.language.toUpperCase()}`"
                placeholder="Question"
                v-model="question.question[domain.language]"
              ></base-input>
              <label>{{ domain.language === 'en' ? `Answer ${domain.language.toUpperCase()} (required field)` : `Answer ${domain.language.toUpperCase()}` }}</label>
              <ckeditor
                v-model="question.answer[domain.language]"
                v-if="activeName === `Text ${domain.language.toUpperCase()}`"
                :config="{ allowedContent: true }"
              ></ckeditor>
            </el-tab-pane>
          </el-tabs>
        </div>
      </card>
      <div class="help-center__sides">
        <card title="Relations">
          <base-input
            label="Doctor alias"
            placeholder="Doctor alias"
            v-model="question.doctor_alias"
          ></base-input>
          <div v-for="field in selectFields" :key="field.label">
            <label>{{ field.label }}</label>
            <el-select
              v-model="$data[field.model]"
              :placeholder="$data[field.label]"
              no-data-text="No data"
              no-match-text="No match"
              filterable
              reserve-keyword
              value-key="id"
              clearable
            >
              <el-option
                v-for="item in field.options"
                :key="item.id"
                :label="item.name.en"
                :value="item.alias.en"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <label>Category (required field)</label>
            <el-select
              v-model="currentCategory"
              placeholder="Category"
              no-data-text="No data"
              no-match-text="No match"
              filterable
              reserve-keyword
              value-key="id"
              clearable
            >
              <el-option
                v-for="category in categoriesList"
                :key="category.id"
                :label="category.title.en"
                :value="category"
              >
              </el-option>
            </el-select>
          </div>
        </card>
        <div>
          <card title="Image">
            <div class="help-center__upload">
              <span class="help-center__upload-title">Question Image</span>
              <img class="help-center__img" v-if="img" :src="img" />
              <button
                class="help-center__upload-button"
                @click="$refs['fileMain'].click()"
              >
                <i>upload</i>
                <input
                  type="file"
                  ref="fileMain"
                  name="fileMain"
                  @change="handleFileUpload"
                  style="position: absolute;left: -5000px;"
                />
              </button>
            </div>
          </card>
          <card title="Others">
            <div class="checkbox-group">
              <div class="checkbox-group__label">
                Enabled on locale
              </div>
              <div class="checkbox-group__group">
                <el-checkbox-group v-model="enabledOnLocales" class="flex">
                  <el-checkbox
                    v-for="domain in domains"
                    :key="domain.language"
                    :label="domain.language"
                    :value="domain.language"
                  />
                </el-checkbox-group>
              </div>
            </div>
            <div class="checkbox-group">
              <div class="checkbox-group__label">
                Is active
              </div>
              <div class="checkbox-group__group">
                <el-switch
                  v-model="isActive"
                  active-color="#a3cc0e"
                  inactive-color="#EAECF0"
                />
              </div>
            </div>
          </card>
        </div>
      </div>
      <div class="help-center__button-wrapper">
        <button class="btn btn-primary" @click.prevent="update">Update</button>
      </div>
    </div>
  </div>
</template>

<script>
import APIHelpCenter from "@/api/modules/help-center";
import { mapActions, mapState } from "vuex";

export default {
  data: () => ({
    activeName: null,
    currentOperation: null,
    currentIllness: null,
    currentDiagnostic: null,
    currentIllnessKind: null,
    currentCountry: null,
    currentCategory: null,
    enabledOnLocales: [],
    isActive: true,
    img: null,
    fileMain: ""
  }),
  computed: {
    ...mapState("helpCenter", ["question"]),
    ...mapState("helpCenterCategories", ["categoriesList"]),
    ...mapState("cmsApiCatalogs", [
      "domains",
      "operations",
      "illnesses",
      "diagnostics",
      "illness-kinds",
      "countries"
    ]),
    illnessKinds() {
      return this["illness-kinds"];
    },
    relativeFields() {
      return [
        { key: "operation", value: this.currentOperation },
        { key: "illness", value: this.currentIllness },
        { key: "diagnostic", value: this.currentDiagnostic },
        { key: "illness_kind", value: this.currentIllnessKind },
        { key: "country", value: this.currentCountry }
      ].filter(item => item.value);
    },
    enabledOnLocaleResult() {
      return this.domains.reduce((acc, { language }) => {
        acc[language] = this.enabledOnLocales.includes(language);
        return acc;
      }, {});
    },
    selectFields() {
      return [
        { label: "Illness", model: "currentIllness", options: this.illnesses },
        {
          label: "Diagnostic",
          model: "currentDiagnostic",
          options: this.diagnostics
        },
        {
          label: "Operation",
          model: "currentOperation",
          options: this.operations
        },
        {
          label: "Illness Kind",
          model: "currentIllnessKind",
          options: this.illnessKinds
        },
        { label: "Country", model: "currentCountry", options: this.countries }
      ];
    }
  },
  created() {
    this.getDomainsEvent();
    this.getOperations();
    this.getIllnesses({ perPage: 1500 });
    this.getCountries({ perPage: 1500 });
    this.getDiagnostics({ perPage: 1500 });
    this.getIllnessKinds({ perPage: 1500 });
    this.getCategoriesList();
    this.getQuestionEvent();
  },
  methods: {
    ...mapActions("helpCenter", ["getQuestion", "addImage"]),
    ...mapActions("helpCenterCategories", ["getCategoriesList"]),
    ...mapActions("cmsApiCatalogs", [
      "getDomains",
      "getOperations",
      "getIllnesses",
      "getCountries",
      "getDiagnostics",
      "getIllnessKinds"
    ]),
    getQuestionEvent() {
      return this.getQuestion(this.$route.params.id).then(() => {
        if (!this.question) return;

        const relationMap = {
          operation: "currentOperation",
          illness: "currentIllness",
          diagnostic: "currentDiagnostic",
          illness_kind: "currentIllnessKind",
          country: "currentCountry"
        };
        this.question.relations?.forEach(({ key, value }) => {
          if (relationMap[key]) {
            this[relationMap[key]] = value;
          }
        });
        this.img = this.question.image
          ? `https://img.bookimed.com/${this.question.image}.jpeg`
          : null;
        this.enabledOnLocales = Object.keys(
          this.question.enabled_on_locale || {}
        ).filter(lang => this.question.enabled_on_locale[lang]);
        this.isActive = !!this.question.is_active;
        this.currentCategory = this.question.category;
      });
    },
    async getDomainsEvent() {
      await this.getDomains();
      this.activeName = `Text ${this.domains[0].language.toUpperCase()}`;
    },
    update() {
      if (!this.question.answer.en || !this.question.question.en){
        return this.$notify({ type: "warning", title: "EN question and answer should not be empty" });
      }
      if (!this.currentCategory){
        return this.$notify({ type: "warning", title: "Please choose category" });
      }
      this.$store.dispatch("setLoader", true);

      return APIHelpCenter.updateQuestion({
        ...this.question,
        relations: this.relativeFields,
        enabled_on_locale: this.enabledOnLocaleResult,
        is_active: +this.isActive,
        category: this.currentCategory
      })
        .then(() => {
          this.addImage({ id: this.$route.params.id, file: this.fileMain });
          this.$notify({ type: "success", title: "Question has been updated" });
        })
        .catch(() => this.$notify({ type: "warning", title: "Error" }))
        .finally(() => this.$store.dispatch("setLoader", false));
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (
        file &&
        (file.type === "image/jpg" ||
          file.type === "image/jpeg" ||
          file.type === "image/png")
      ) {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          this.img = reader.result;
        });
        reader.readAsDataURL(file);
        this.fileMain = file;
        return;
      }
      alert("Make sure your photos have .jpg, .jpeg, file types");
      return;
    }
  }
};
</script>
